import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { global } from '../../shared/global';
import { NgxSpinnerService } from 'ngx-spinner';
import {BookinghistoryService} from './bookinghistory.service';

@Component({
  selector: 'app-bookinghistory',
  templateUrl: './bookinghistory.component.html',
  styleUrls: ['./bookinghistory.component.css']
})
export class BookinghistoryComponent implements OnInit {

  bookingHistories: any;
  cookieValue: any;
  termConditionLink: any;
  responseData: any;

  constructor(private cookieService: CookieService, private service: BookinghistoryService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.termConditionLink = global.termConditionLink;

    this.cookieValue = this.cookieService.get("login");

    if(this.cookieValue) {
      this.cookieValue = JSON.parse(this.cookieService.get("login"));
      this.fillBookingHistory(this.cookieValue.mobile);
    } else {
    }
  }

  fillBookingHistory(mobileNo) {
    var objBook = {
      "mobile":mobileNo
    }

    this.spinner.show();
      this.service.getBookingHistory(objBook)
        .subscribe(data => {
          this.responseData = data;
          if (this.responseData.status == false) {
            this.spinner.hide();
            document.getElementById("divMsg").style.display = "block";
          }
          else {
            this.bookingHistories = this.responseData.data;
            this.spinner.hide();
            document.getElementById("divMsg").style.display = "none";
          }
        });
  }
}
